import { default_header, default_header_example } from './defaultData';

const data = (userInfo) => ({
  title: 'G마켓물류',
  children: [
    {
      title: '주문 리스트 조회',
      pageTitle: 'G마켓물류 주문 리스트 조회',
      url: '/doc/G마켓물류 주문 리스트 조회',
      data: [
        {
          version: 'v1.0',
          url: '/ebayOrders',
          desc: '주문 > G마켓 물류서비스 주문 리스트를 가져옵니다.',
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  검색 시작 값
                  <div className='description'>
                    기본값 0부터 시작됩니다. 
                    <ul className='style'>
                      <li>start: 0, length: 1000 으로 검색한 경우, 검색결과의 index 0-999건까지 검색됩니다.</li>
                      <li>다음 주문건을 검색하기 위해서는 이전 입력한 start, length 프로퍼티의 값을 고려하여 start: 1000 을 입력하여 호출합니다.</li>
                      <li><strong>recordsTotal에 묶음번호별 그룹핑된 주문의 총개수가 출력됩니다.</strong></li>
                      <li><strong>results에 출력된 주문을 묶음번호별 그룹핑된 배열로 변환 후 해당 배열의 길이를 <code>start</code>에 넣어 다음 주문건을 검색해야 합니다.</strong></li>
                    </ul>
                    <div style={{ padding: '12px 0' }}>
                      <strong>Default value: <code>0</code></strong><br />
                    </div>
                  </div>
                </div>
              )
            },
            {
              title: 'length',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  조회할 주문 갯수
                  <ul className='style'>
                    <li><strong>recordsTotal에 묶음번호별 그룹핑된 주문의 총개수가 출력됩니다.<br/>총개수를 고려하여 length 설정해야 합니다.</strong></li>
                  </ul>
                  <div className='description'>
                    묶음주문 기준 최대 1000건 단위로 검색 가능합니다.<br />
                    <div style={{ padding: '12px 0' }}>
                      <strong>Max value: <code>1000</code></strong><br />
                      <strong>Default value: <code>500</code></strong>
                    </div>
                  </div>
                </div>
              ),
            },
            {
              title: 'orderby',
              required: '',
              type: 'String',
              desc: (
                <div>
                  정렬
                  <div className='description' style={{ padding: '12px 0' }}>
                    <ul className='style'>
                      <li>
                        <code>값을 넣지 않는 경우 등록일 기준 오름차순으로 검색됩니다.</code>
                      </li>
                      <li>
                        <code>아래의 정렬 가능 필드와 asc/desc를 조합하여 입력합니다. (orderby: wdate desc)</code>
                      </li>
                    </ul>
                    <br />
                    <br />
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>bundle_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>묶음번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ord_status</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문상태</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문수집일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰 계정</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_ord_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문번호</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색 키<br />
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>bundle_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>묶음번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_ord_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ebaydepot_uniq</code>
                          </strong>
                        </td>
                        <td>
                          <strong>G마켓 물류 연동 주문번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰 상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>sku_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>SKU코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>set_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>세트코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>stock_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>재고관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>c_sale_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>판매자관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>prod_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>SKU상품명</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_opt_name, shop_add_opt_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>옵션명, 추가구매옵션</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>order_name, order_id, to_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문자, 주문자아이디, 수령자</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>tel</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문자, 수령자 연락처</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>memo</code>
                          </strong>
                        </td>
                        <td>
                          <strong>메모</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>gift_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>사은품</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>invoice_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>운송장번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>barcode</code>
                          </strong>
                        </td>
                        <td>
                          <strong>바코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ship_msg</code>
                          </strong>
                        </td>
                        <td>
                          <strong>배송메시지</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <strong>
                    <ul className='style'>
                      <li>
                        <code>값을 넣지않는경우 전체검색됩니다.</code>
                      </li>
                    </ul>
                  </strong>
                </div>
              ),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색타입
                  <br />
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>exact</code>
                          </strong>
                        </td>
                        <td>
                          <strong>완전일치</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                        <td>
                          <strong>부분일치</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'date_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  날짜검색타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문수집일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ebaydepot_shipinfo_wdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>발송정보 등록일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ebaydepot_ship_req_date</code>
                          </strong>
                        </td>
                        <td>
                          <strong>G마켓 물류 발송요청일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ord_time</code>
                          </strong>
                        </td>
                        <td>
                          <strong>주문일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>pay_time</code>
                          </strong>
                        </td>
                        <td>
                          <strong>결제 완료일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ship_plan_date</code>
                          </strong>
                        </td>
                        <td>
                          <strong>발송예정일</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sdate',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  검색시작일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
            },
            {
              title: 'edate',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  검색종료일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
            },
            {
              title: 'ebaydepot_send_avail_yn',
              required: '',
              type: 'Boolean',
              desc: '발송정보 전송가능 여부',
            },
            {
              title: 'multi_bundle_yn',
              required: '',
              type: 'Boolean',
              desc: '합포장 여부',
            },
            {
              title: 'shop_id',
              required: '',
              type: 'String',
              desc: '쇼핑몰아이디',
            },
            {
              title: 'shop_cd',
              required: '',
              type: 'String',
              desc: (
                <div>
                  쇼핑몰코드
                  <div className='description'>
                    (옥션:A001, 지마켓: A006, 11번가: A112, 바이즐: A027...)
                  </div>
                </div>
              ),
            },
            {
              title: 'status',
              required: '',
              type: 'String[]',
              desc: (
                <div>
                  주문상태
                  <div className='description'>
                    전체조회시 ["ALL"]
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>결제완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>신규주문</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>주문보류</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>출고대기</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>출고보류</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>운송장출력</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>출고완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>배송중</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>배송완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>구매결정</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>판매완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>취소요청</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>취소완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품요청</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품진행</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품회수완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>교환요청</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>교환진행</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>교환완료</code>
                          </strong>
                        </td>
                        <td> 
                          <strong>
                            <code>맞교환요청</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>맞교환완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>주문재확인</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'status_sub',
              required: '',
              type: 'String[]',
              desc: (
                <div>
                  G마켓물류 연동상태
                  <div className='description'>
                    전체조회시 ["ALL"]
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>발송정보 미등록</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송정보 수정대기</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송요청 대기</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송요청중</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>발송요청 완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송요청 실패</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>판매취소 완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송 완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>발송정보 전송실패</code>
                          </strong>
                        </td>
                        <td colSpan='3'></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'delivery_vendor',
              required: '',
              type: 'String',
              desc: '배송처 코드',
            },
            {
              title: 'gift_prod_name',
              required: '',
              type: 'String',
              desc: '규칙적용 사은품',
            },
            {
              title: 'delay_status',
              required: '',
              type: 'Boolean',
              desc: '배송지연여부',
            },
            {
              title: 'supp_vendor',
              required: '',
              type: 'String',
              desc: '매입처 코드',
            },
            {
              title: 'multi_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  멀티검색 키
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>c_sale_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>판매자관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>ebaydepot_uniq</code>
                          </strong>
                        </td>
                        <td>
                          <strong>G마켓 물류 연동 주문번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_sale_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰상품코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>bundle_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>묶음번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>sku_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>SKU코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>set_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>세트코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>stock_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>재고관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop_ord_no</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰주문번호</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>shop</code>
                          </strong>
                        </td>
                        <td>
                          <strong>쇼핑몰아이디</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_search_word',
              required: '',
              type: 'String | Object[]',
              desc: (
                <div>
                  멀티검색어 ( \n 으로 묶어서 전송 ) ex&gt; 하나\n둘\n셋\n넷
                  <div className='description'>
                    <br />
                    multi_type이 shop인 경우에는 Object[] 타입으로 설정합니다.
                  </div>                  
                  <table>
                    <thead>
                      <tr>
                        <th>변수(Parameter)</th>
                        <th>타입(Type)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>multi_search_word</td>
                        <td>Object[]</td>
                      </tr>
                      <tr>
                        <td>
                          <span class="DescriptionPageTemplate_indent__tubP9"></span>
                          shop_cd
                        </td>
                        <td>String</td>
                      </tr>
                      <tr>
                        <td>
                          <span class="DescriptionPageTemplate_indent__tubP9"></span>
                          shop_id
                        </td>
                        <td>String</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'masking_yn',
              required: '',
              type: 'Boolean',
              desc: (
                <div>
                  개인정보 마스킹 처리 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    <strong>Default value : <code>false</code></strong>
                  </div>
                </div>
              ),
            }
          ],
          body_example: {
            start: 0,
            length: 100,
            orderby: 'wdate desc',
            date_type: 'wdate',
            sdate: '2025-09-01',
            edate: '2025-09-15',
            status_sub: ['발송정보 미등록'],
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: '',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'uniq',
              required: 'O',
              type: 'String(20)',
              desc: '주문 고유번호',
              indent: 1,
            },
            {
              title: 'ori_uniq',
              required: 'O',
              type: 'String(20)',
              desc: (
                <div>
                  원본 주문 고유번호
                  <div className='description'>(사본주문인 경우)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'bundle_no',
              required: 'O',
              type: 'String',
              desc: '주문 묶음번호',
              indent: 1,
            },
            {
              title: 'ord_status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  주문상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>결제완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>신규주문</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>주문보류</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>출고대기</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>출고보류</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>운송장출력</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>출고완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>배송중</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>배송완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>구매결정</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>판매완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>취소요청</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>취소완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품요청</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품진행</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품회수완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>반품완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>교환요청</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>교환진행</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>교환완료</code>
                          </strong>
                        </td>
                        <td> 
                          <strong>
                            <code>맞교환요청</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>맞교환완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>주문재확인</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'carr_no',
              required: 'O',
              type: 'Number(5)',
              desc: '택배사코드',
              indent: 1,
            },
            {
              title: 'carr_ser_no',
              required: 'O',
              type: 'Number(5)',
              desc: '택배사 서비스 코드',
              indent: 1,
            },
            {
              title: 'carr_name',
              required: 'O',
              type: 'String(30)',
              desc: '택배사 이름',
              indent: 1,
            },
            {
              title: 'carr_ser_name',
              required: 'O',
              type: 'String(30)',
              desc: '택배사 서비스 이름',
              indent: 1,
            },
            {
              title: 'invoice_no',
              required: 'O',
              type: 'String(20)',
              desc: '운송장 번호',
              indent: 1,
            },
            {
              title: 'ship_plan_date',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  배송예정일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_cd',
              required: 'O',
              type: 'String(4)',
              desc: '쇼핑몰 코드',
              indent: 1,
            },
            {
              title: 'shop_name',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 이름',
              indent: 1,
            },
            {
              title: 'shop_id',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 계정',
              indent: 1,
            },
            {
              title: 'seller_nick',
              required: 'O',
              type: 'String(50)',
              desc: '판매자 별칭',
              indent: 1,
            },
            {
              title: 'shop_ord_no',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰 주문번호',
              indent: 1,
            },
            {
              title: 'shop_sale_no',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰 판매번호',
              indent: 1,
            },
            {
              title: 'shop_sale_name',
              required: 'O',
              type: 'String(255)',
              desc: '상품명',
              indent: 1,
            },
            {
              title: 'shop_sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: '쇼핑몰에서 수집된 sku_cd',
              indent: 1,
            },
            {
              title: 'shop_opt_name',
              required: 'O',
              type: 'String(250)',
              desc: '옵션명',
              indent: 1,
            },
            {
              title: 'sale_cnt',
              required: 'O',
              type: 'Number(8)',
              desc: '주문수량',
              indent: 1,
            },
            {
              title: 'shop_add_opt_name',
              required: 'O',
              type: 'String(255)',
              desc: '추가구매옵션명',
              indent: 1,
            },
            {
              title: 'ship_method',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  배송방법
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>무료배송</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>선결제</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>착불</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>조건부배송</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>방문수령</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>퀵배송</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>일반우편</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>설치배송</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>기타</code>
                          </strong>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'out_time',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  출고일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  주문수집일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ord_time',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  주문일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'pay_time',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  결제완료일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  주문 수정일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ord_confirm_time',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  주문확인일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'sales',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  판매금액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'sales_tax',
              required: 'O',
              type: 'Number(11)',
              desc: (
                <div>
                  부가세
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'discount_amt',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  할인금액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'pay_amt',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  실결제금액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  쇼핑몰 원가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  쇼핑몰 공급가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ship_delay_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '배송지연여부',
              indent: 1,
            },
            {
              title: 'order_name',
              required: 'O',
              type: 'String(30)',
              desc: '주문자 명',
              indent: 1,
            },
            {
              title: 'order_id',
              required: 'O',
              type: 'String(30)',
              desc: '주문자 아아디',
              indent: 1,
            },
            {
              title: 'order_tel',
              required: 'O',
              type: 'String(20)',
              desc: '주문자 전화번호',
              indent: 1,
            },
            {
              title: 'order_htel',
              required: 'O',
              type: 'String(20)',
              desc: '주문자 휴대폰번호',
              indent: 1,
            },
            {
              title: 'order_email',
              required: 'O',
              type: 'String(50)',
              desc: '주문자 이메일',
              indent: 1,
            },
            {
              title: 'ship_msg',
              required: 'O',
              type: 'String(65535)',
              desc: '배송메세지',
              indent: 1,
            },
            {
              title: 'out_order_time',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  출고지시일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'to_ctry_cd',
              required: 'O',
              type: 'String(2)',
              desc: '수령자 국가',
              indent: 1,
            },
            {
              title: 'to_name',
              required: 'O',
              type: 'String(30)',
              desc: '수령자 명',
              indent: 1,
            },
            {
              title: 'to_tel',
              required: 'O',
              type: 'String(30)',
              desc: '수령자 전화번호',
              indent: 1,
            },
            {
              title: 'to_htel',
              required: 'O',
              type: 'String(30)',
              desc: '수령자 휴대폰번호',
              indent: 1,
            },
            {
              title: 'to_addr1',
              required: 'O',
              type: 'String(255)',
              desc: '수령자 주소 1',
              indent: 1,
            },
            {
              title: 'to_addr2',
              required: 'O',
              type: 'String(255)',
              desc: '수령자 주소 2',
              indent: 1,
            },
            {
              title: 'to_zipcd',
              required: 'O',
              type: 'String(10)',
              desc: '수령자 우편번호',
              indent: 1,
            },
            {
              title: 'ship_cost',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  배송비
                  <div className='description'>(data type: Decimal(8,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'c_sale_cd',
              required: 'O',
              type: 'String(40)',
              desc: '판매자관리코드',
              indent: 1,
            },
            {
              title: 'ord_curr_cd',
              required: 'O',
              type: 'String(4)',
              desc: '통화',
              indent: 1,
            },
            {
              title: 'shop_discount',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  쇼핑몰부담할인액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'seller_discount',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  판매자부담할인액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'coupon_discount',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  쿠폰할인액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'point_discount',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  포인트할인액
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'gprivate_no',
              required: 'O',
              type: 'String(50)',
              desc: '개인통관번호',
              indent: 1,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(40)',
              desc: '바코드',
              indent: 1,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(8)',
              desc: '배송처 코드',
              indent: 1,
            },
            {
              title: 'depot_name',
              required: 'O',
              type: 'String(45)',
              desc: '배송처 이름',
              indent: 1,
            },
            {
              title: 'invoice_send_time',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  운송장 전송일
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'gift_name',
              required: 'O',
              type: 'String(50)',
              desc: '쇼핑몰에서 수집된 사은품정보',
              indent: 1,
            },
            {
              title: 'map_yn',
              required: 'O',
              type: 'Number(1)',
              desc: 'SKU상품 매칭여부',
              indent: 1,
            },
            {
              title: 'ship_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '출고가능 여부',
              indent: 1,
            },
            {
              title: 'ship_unable_reason',
              required: 'O',
              type: 'String(100)',
              desc: '출고불가 이유',
              indent: 1,
            },
            {
              title: 'ord_status_msg',
              required: 'O',
              type: 'String(255)',
              desc: '클레임 사유',
              indent: 1,
            },
            {
              title: 'exchange_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '교환여부',
              indent: 1,
            },
            {
              title: 'memo_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '메모 유무',
              indent: 1,
            },
            {
              title: 'memo_complete_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '메모 완료 여부',
              indent: 1,
            },
            {
              title: 'bundle_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '합포장여부',
              indent: 1,
            },
            {
              title: 'set_no',
              required: 'O',
              type: 'Number(10)',
              desc: '세트 번호',
              indent: 1,
            },
            {
              title: 'set_cd',
              required: 'O',
              type: 'String(40)',
              desc: '세트 코드',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(6)',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'set_name',
              required: 'O',
              type: 'String(200)',
              desc: '세트상품명',
              indent: 1,
            },
            {
              title: 'pay_method',
              required: 'O',
              type: 'String(20)',
              desc: (
                <div>
                  결제방법
                  <div className='description'>
                    ( 0:현금, 1:카드, 2:이머니, 3:알수없음 )
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'notice_msg',
              required: 'O',
              type: 'String(60)',
              desc: (
                <div>
                  기타메세지
                  <div className='description'>
                    (특정쇼핑몰만 처리되는 특이사항이 있는경우 사용됩니다.)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'shop_ship_no',
              required: 'O',
              type: 'String(30)',
              desc: '쇼핑몰 배송 번호',
              indent: 1,
            },
            {
              title: 'ebaydepot_uniq',
              required: 'O',
              type: 'String(20)',
              desc: 'G마켓 물류 연동 주문번호',
              indent: 1,
            },
            {
              title: 'ebaydepot_link_status',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  G마켓물류 연동상태
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>발송정보 미등록</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송정보 수정대기</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송요청 대기</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송요청중</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>발송요청 완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송요청 실패</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>판매취소 완료</code>
                          </strong>
                        </td>
                        <td>
                          <strong>
                            <code>발송 완료</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>발송정보 전송실패</code>
                          </strong>
                        </td>
                        <td colSpan='3'></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ebaydepot_shipinfo_wdate',
              required: '',
              type: 'String(10)',
              desc: (
                <div>
                  G마켓 물류 발송정보 등록일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ebaydepot_ship_req_date',
              required: '',
              type: 'String(10)',
              desc: (
                <div>
                  G마켓 물류 발송요청일
                  <div className='description'>(YYYY-MM-DD)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'ebaydepot_send_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '발송정보 전송가능 여부',
              indent: 1,
            },
            {
              title: 'ebaydepot_send_unable_reson',
              required: 'O',
              type: 'String(100)',
              desc: '발송정보 전송불가 이유',
              indent: 1,
            },
            {
              title: 'gift_rule',
              required: 'O',
              type: 'Object',
              desc: '적용된 사은품 규칙 (묶음 주문은 적용된 규칙 사은품이 각 주문 별로 모두 출력됩니다.)',
              indent: 1,
            },
            {
              title: 'name',
              required: 'O',
              type: 'String(50)',
              desc: '사은품명',
              indent: 2,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: 'sku 코드',
              indent: 2,
            },
            {
              title: 'count',
              required: 'O',
              type: 'Number(8)',
              desc: '사은품 출고갯수',
              indent: 2,
            },
            {
              title: 'gift_name',
              required: 'O',
              type: 'String(50)',
              desc: '제공 사은품명',
              indent: 2,
            },
            {
              title: 'gift_rule_name',
              required: 'O',
              type: 'String(50)',
              desc: '사은품 규칙명',
              indent: 2,
            },
            {
              title: 'results_prod',
              required: 'O',
              type: 'Object[]',
              desc: '매칭된 SKU상품 정보',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'uniq',
              required: 'O',
              type: 'String(20)',
              desc: '주문 고유번호',
              indent: 1,
            },
            {
              title: 'bundle_no',
              required: 'O',
              type: 'Number(20)',
              desc: '주문묶음번호',
              indent: 1,
            },
            {
              title: 'ord_opt_seq',
              required: 'O',
              type: 'Number(5)',
              desc: '옵션순번',
              indent: 1,
            },
            {
              title: 'add_opt_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '추가구매옵션여부',
              indent: 1,
            },
            {
              title: 'ord_opt_name',
              required: 'O',
              type: 'Number(120)',
              desc: '옵션명',
              indent: 1,
            },
            {
              title: 'set_cd',
              required: 'O',
              type: 'String(40)',
              desc: '매칭된 세트코드',
              indent: 1,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: '매칭된 SKU상품 고유번호',
              indent: 1,
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: '매칭된 SKU상품명',
              indent: 1,
            },
            {
              title: 'attri',
              required: 'O',
              type: 'String(50)',
              desc: '매칭된 SKU상품 속성',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: '매칭된 SKU상품 sku코드',
              indent: 1,
            },
            {
              title: 'stock_cd',
              required: 'O',
              type: 'String(100)',
              desc: '매칭된 SKU상품 재고관리코드',
              indent: 1,
            },
            {
              title: 'bundle_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: '합포장가능여부',
              indent: 1,
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(40)',
              desc: '매칭된 SKU상품 바코드',
              indent: 1,
            },
            {
              title: 'opt_sale_cnt',
              required: 'O',
              type: 'Number(8)',
              desc: '옵션수량',
              indent: 1,
            },
            {
              title: 'pack_unit',
              required: 'O',
              type: 'Number(6)',
              desc: '출고수량',
              indent: 1,
            },
            {
              title: 'recordsTotal',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  검색된 전체 주문건수
                  <div>
                    <strong>
                      <code>묶음주문기준</code>
                    </strong>
                  </div>
                </div>
              ),
            },
            {
              title: 'recordsTotalCount',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  검색된 전체 주문건수
                  <div>
                    <strong>
                      <code>단건주문기준</code>
                    </strong>
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    묶음주문 내의 단건주문의 주문건수로, 합포장된 주문의 개수에 따라<br />
                    묶음주문기준 주문건수(recordsTotal)보다 많을 수 있습니다.
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th colSpan='2'>단건주문 2, 3개가 각각 합포장 처리된 묶음주문 2건을 조회시</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>recordsTotal</code>
                          </strong>
                        </td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>recordsTotalCount</code>
                          </strong>
                        </td>
                        <td>5</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
              ),
            },
          ],
          response_example: {
            results: [
              {
                sol_no: '솔루션 번호',
                uniq: '주문 고유번호',
                ori_uniq: '원본 주문 고유번호 (사본주문인경우)',
                bundle_no: '주문 묶음번호',
                ord_status:
                  '주문상태 (결제완료, 신규주문, 주문보류, 출고대기, 출고보류, 운송장출력, 출고완료, 배송중, 배송완료, 구매결정, 판매완료, 취소요청, 취소완료, 반품요청, 반품진행, 반품회수완료, 반품완료, 교환요청, 교환진행, 교환완료, 맞교환요청, 맞교환완료, 주문재확인)',
                carr_no: '택배사 코드',
                carr_ser_no: '택배사 서비스 코드',
                carr_name: '택배사 이름',
                carr_ser_name: '택배사 서비스 이름',
                invoice_no: '운송장 번호',
                ship_plan_date: '배송예정일',
                shop_cd: '쇼핑몰 코드',
                shop_name: '쇼핑몰 이름',
                shop_id: '쇼핑몰 계정',
                seller_nick: '판매자 별칭',
                shop_ord_no: '쇼핑몰 주문번호',
                shop_sale_no: '쇼핑몰 판매번호',
                shop_sale_name: '상품명',
                shop_sku_cd: '쇼핑몰에서 수집된 SKU코드',
                shop_opt_name: '옵션명',
                sale_cnt: '주문수량',
                shop_add_opt_name: '추가구매옵션명',
                ship_method: '배송방법',
                out_time: '출고일',
                wdate: '주문수집일',
                ord_time: '주문일',
                pay_time: '결제완료일',
                mdate: '툴에서 주문수정일',
                ord_confirm_time: '주문확인일',
                sales: '판매금',
                sales_tax: '부가세',
                discount_amt: '할인금액',
                pay_amt: '실결제금액',
                shop_cost_price: '쇼핑몰 원가',
                shop_supply_price: '쇼핑몰 공급가',
                ship_delay_yn: '배송지연여부',
                order_name: '주문자 명',
                order_id: '주문자 아아디',
                order_tel: '주문자 전화번호',
                order_htel: '주문자 휴대폰번호',
                order_email: '주문자 이메일',
                ship_msg: '배송메세지',
                out_order_time: '출고지시일',
                to_ctry_cd: '수령자 국가',
                to_name: '수령자 명',
                to_tel: '수령자 전화번호',
                to_htel: '수령자 휴대폰번호',
                to_addr1: '수령자 주소 1',
                to_addr2: '수령자 주소 2',
                to_zipcd: '수령자 우편번호',
                ship_cost: '배송비',
                c_sale_cd: '판매자관리코드',
                ord_curr_cd: '통화',
                shop_discount: '쇼핑몰부담할인액',
                seller_discount: '판매자부담할인액',
                coupon_discount: '쿠폰할인액',
                point_discount: '포인트할인액',
                gprivate_no: '개인통관번호',
                barcode: '바코드',
                depot_no: '배송처 코드',
                depot_name: '배송처 이름',
                invoice_send_time: '운송장 전송일',
                gift_name: '사은품',
                map_yn: 'SKU상품 매칭여부',
                ship_avail_yn: '출고가능 여부',
                ship_unable_reason: '출고불가 이유',
                ord_status_msg: '클레임 사유',
                exchange_yn: '교환여부',
                memo_yn: '메모 유무',
                memo_complete_yn: '메모 완료 유무',
                bundle_avail_yn: '합포장여부',
                set_no: '세트 번호',
                set_cd: '세트 코드',
                pack_unit: '출고수량',
                set_name: '세트상품명',
                pay_method: '결제방법',
                notice_msg: '기타메세지',
                shop_ship_no: '쇼핑몰 배송 번호',
                ebaydepot_uniq: 'G마켓 물류 연동 주문번호',
                ebaydepot_link_status: 'G마켓물류 연동상태',
                ebaydepot_shipinfo_wdate: 'G마켓 물류 발송정보 등록일',
                ebaydepot_ship_req_date: 'G마켓 물류 발송요청일',
                ebaydepot_send_avail_yn: '발송정보 전송가능 여부',
                ebaydepot_send_unable_reson: '발송정보 전송불가 이유',
                gift_rule: [
                  {
                    name: '사은품규칙 이름',
                    sku_cd: '사은품규칙 sku 코드',
                    count: '사은품규칙 출고수량',
                    gift_name: '제공 사은품명',
                    gift_rule_name: '사은품 규칙명',
                  },
                ],
              }
            ],
            results_prod: [
              {
                sol_no: '솔루션번호',
                uniq: '주문 고유번호',
                bundle_no: '주문묶음번호',
                ord_opt_seq: '옵션순번',
                add_opt_yn: '추가구매옵션여부',
                ord_opt_name: '옵션명',
                set_cd: '세트코드',
                prod_no: '매칭된 SKU상품 고유번호',
                prod_name: '매칭된 SKU상품명',
                attri: '매칭된 SKU상품 속성',
                sku_cd: '매칭된 SKU상품 sku코드',
                stock_cd: '매칭된 SKU상품 재고관리코드',
                bundle_avail_yn: '합포장가능여부',
                barcode: '매칭된 SKU상품 바코드',
                opt_sale_cnt: '옵션수량',
                pack_unit: '출고수량',
              },
            ],
            recordsTotal: '검색된 전체 묶음 주문건수',
            recordsTotalCount: '검색된 전체 주문건수',
            statusSubCount: {
              '발송정보 미등록': 'G마켓물류에 발송정보를 등록하지 않은 주문건수',
              '발송정보 수정대기': 'G마켓물류에 발송정보 전송 후 수정한 정보가 전송되지 않은 주문건수',
              '발송요청 대기': 'G마켓물류에 발송정보가 등록되었으나 발송요청이 되지않은 주문건수',
              '발송요청중': 'G마켓물류에 발송을 요청중인 주문건수',
              '발송요청 완료': 'G마켓물류에 발송요청이 정상으로 접수된 주문건수',
              '발송요청 실패': 'G마켓물류에 발송요청을 했으나 실패된 주문건수',
              '판매취소 완료': 'G마켓물류에 발송요청 완료 후 판매취소 처리한 주문건수',
              '발송 완료': '‘G마켓물류에서 상품이 출고되어 배송정보가 업데이트 된 주문건수',
              '발송정보 전송실패': 'G마켓물류에 발송정보를 전송하였으나 실패된 주문건수',
            },
          },
        },
      ],
    },
    ...(userInfo.work_use_yn === 1 ? [
      {
        title: '작업 등록',
        pageTitle: 'G마켓물류 작업 등록',
        url: '/doc/G마켓물류 작업 등록',
        data: [
          {
            version: 'v1.0',
            url: '/work/addEbayWork',
            method: 'POST',
            desc: (
              <ul className='style'>
                <li>
                  <p>전송하는 G마켓물류 주문/상품데이터에 적용될 작업을 등록합니다.</p>
                </li>
                <li>
                  <p>
                    <a href='/doc/작업결과 조회' style={{ color: 'blue' }}>작업결과 조회 </a>|&nbsp;
                    <a href='/doc/작업리스트 조회' style={{ color: 'blue' }}>작업리스트 조회 </a>|&nbsp;
                    <a href='/doc/작업 삭제' style={{ color: 'blue' }}>작업 삭제 </a>&nbsp;API 는 일반 쇼핑몰 작업 API와 동일합니다. 
                  </p>
                </li>
                <li>
                  <p>
                    호출가능한 액션은 아래와 같습니다. <br />
                    <br />
                  </p>
                  <table width='700px'>
                    <tbody>
                      <tr>
                        <th colSpan='2'>주문</th>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>SEND_ORDER</font>
                        </td>
                        <td>
                          발송정보 전송/수정 <br/>
                          <code>작업명: G마켓 물류 발송정보 전송</code>
                        </td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>REQUEST_ORDER</font>
                        </td>
                        <td>
                          발송요청 <br/>
                          <code>작업명: G마켓 물류 발송요청</code>
                        </td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>DELETE_ORDER</font>
                        </td>
                        <td>
                          발송정보 삭제 <br/>
                          <code>작업명: G마켓 물류 발송정보 삭제</code>
                        </td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>CANCEL_ORDER</font>
                        </td>
                        <td>
                          판매취소 <br/>
                          <code>작업명: G마켓 물류 판매취소</code>
                        </td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>SYNC_STATE_ORDER</font>
                        </td>
                        <td>
                          발송요청상태 동기화 <br/>
                          <code>작업명: G마켓 물류 발송요청상태 동기화</code>
                        </td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>SYNC_DELIV_ORDER</font>
                        </td>
                        <td>
                          운송장정보 동기화 <br/>
                          <code>작업명: G마켓 물류 운송장정보 동기화</code>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                  <table width='700px'>
                    <tbody>
                      <tr>
                        <th colSpan='2'>재고</th>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>SCRAP_SKU</font>
                        </td>
                        <td>
                          SKU 가져오기 <br/>
                          <code>작업명: G마켓 물류 SKU 가져오기</code>
                        </td>
                      </tr>
                      <tr>
                        <td width='200px'>
                          <font color='red'>SYNC_SKU</font>
                        </td>
                        <td>
                          SKU 동기화 <br/>
                          <code>작업명: G마켓 물류 SKU 동기화</code>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </li>
                <li>
                  <p>
                  <code>api_callback_url</code> 등록시 작업결과를 POST 방식으로
                  입력하신 주소로 전송합니다. <br />
                  - 작업등록이 성공한 경우에만 결과데이터를 받아보실 수 있습니다.<br />
                  - 전송되는 데이터 포멧은 아래의 예시를 참고해주세요.
                  </p>
                  <pre className='prettyprint'>
                    ---- 작업 결과 ----
                    <br />{'{'}
                    <br />  "work_no": 828323274,
                    <br />  "job_name": "G마켓 물류 SKU 동기화",
                    <br />  "status": "완료",
                    <br />  "message": [
                    <br />    '[성공] : 26건 성공 / 2건 실패<br />SABC12345 - 재고현황 조회 가능한 SKU 상태가 아닙니다. 현재상태 : SI302(입고대기)<br />SDEF67890 - 재고현황 조회 가능한 SKU 상태가 아닙니다. 현재상태 : SI302(입고대기)'
                    <br />  ]
                    <br />{'}'}
                  </pre>                  
                </li>
              </ul>
            ),
            header: default_header,
            header_example: default_header_example,
            body: [
              {
                title: 'work_type',
                required: 'O',
                type: 'String',
                desc: (
                  <div>
                    작업액션
                    <div className='description' style={{ padding: '12px 0' }}>
                      Allowed values
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              <code>SEND_ORDER</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>REQUEST_ORDER</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>DELETE_ORDER</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>CANCEL_ORDER</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>SYNC_STATE_ORDER</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>SYNC_DELIV_ORDER</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>SCRAP_SKU</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>SYNC_SKU</code>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ),
              },
              {
                title: 'depot_no',
                required: '',
                type: 'Number',
                desc: (
                  <div>
                    배송처번호
                    <div className='description'>
                      SCRAP_SKU, SYNC_STATE_ORDER, SYNC_DELIV_ORDER 작업 시 필수입니다.
                    </div>
                  </div>
                ),
              },
              {
                title: 'list',
                required: '',
                type: 'String[]',
                desc: (
                  <div>
                    SKU 코드 또는 주문 고유번호
                    <div className='description'>
                      SYNC_SKU, SEND_ORDER, REQUEST_ORDER, DELETE_ORDER, CANCEL_ORDER <br />
                      작업 시 필수입니다.
                    </div>
                    <ul className='style' style={{ color: 'gray' }}>
                      <li>주문: uniq</li>
                      <li>재고: sku_cd(SKU코드)</li>
                    </ul>
                  </div>
                ),
              },
              {
                title: 'include_pending_sku_yn',
                required: '',
                type: 'Boolean',
                desc: (
                  <div>
                    입고대기 SKU 상품 포함 여부
                    <div className='description'>
                      SCRAP_SKU 작업시 사용됩니다.
                    </div>
                    <div className='description' style={{ padding: '12px 0' }}>
                      Default value
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              <code>false</code>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div className='description' style={{ padding: '12px 0' }}>
                      Allowed values
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              <code>true</code>
                            </strong>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>false</code>
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ),
              },
              {
                title: 'sdate',
                required: '',
                type: 'String',
                desc: (
                  <div>
                    검색시작일
                    <div className='description'>
                      SYNC_STATE_ORDER, SYNC_DELIV_ORDER 작업시 사용됩니다. <br />
                      미입력시 최근 4일 이내 주문대상으로 작업이 등록됩니다.
                    </div>
                  </div>
                ),
              },
              {
                title: 'edate',
                required: '',
                type: 'String',
                desc: (
                  <div>
                    검색종료일
                    <div className='description'>
                      SYNC_STATE_ORDER, SYNC_DELIV_ORDER 작업시 사용됩니다. <br />
                      미입력시 최근 4일 이내 주문대상으로 작업이 등록됩니다.
                    </div>
                  </div>
                ),
              },
              {
                title: 'fields',
                required: '',
                type: 'String[]',
                desc: (
                  <div>
                    SKU 동기화 항목
                    <div className='description'>
                      SYNC_SKU 작업 시 필수입니다.
                    </div>
                    <div className='description' style={{ padding: '12px 0' }}>
                      Allowed values
                    </div>
                    <table>
                      <thead>
                        <tr>
                          <th>Value</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>
                              <code>prod_name</code>
                            </strong>
                          </td>
                          <td>
                            상품명
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>barcode</code>
                            </strong>
                          </td>
                          <td>
                            바코드
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>brand</code>
                            </strong>
                          </td>
                          <td>
                            브랜드
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>maker</code>
                            </strong>
                          </td>
                          <td>
                            제조사
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>bundle_avail_yn</code>
                            </strong>
                          </td>
                          <td>
                            합포장여부
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>stock_cd</code>
                            </strong>
                          </td>
                          <td>
                            재고관리코드
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <strong>
                              <code>stock_cnt_real</code>
                            </strong>
                          </td>
                          <td>
                            수량
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                ),
              },
              {
                title: 'api_callback_url',
                required: '',
                type: 'String',
                desc: (
                  <div>
                    작업완료시 작업결과를 수신받을 URL
                    <div className='description'>
                      해당정보 입력시 작업결과를 입력하신 주소로 POST 방식으로
                      전송합니다.
                    </div>
                  </div>
                ),
              },
            ],
            body_example: [
              '# G마켓 물류 발송정보 전송',
              {
                work_type: 'SEND_ORDER',
                list: [
                  '3782381925823309795',
                  '3782381925823309796',
                  '3782381925823309797',
                ],
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 발송요청',
              {
                work_type: 'REQUEST_ORDER',
                list: [
                  '3782381925823309795',
                  '3782381925823309796',
                  '3782381925823309797',
                ],
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 발송정보 삭제',
              {
                work_type: 'DELETE_ORDER',
                list: [
                  '3782381925823309795',
                  '3782381925823309796',
                  '3782381925823309797',
                ],
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 판매취소',
              {
                work_type: 'CANCEL_ORDER',
                list: [
                  '3782381925823309795',
                  '3782381925823309796',
                  '3782381925823309797',
                ],
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 발송요청상태 동기화',
              {
                work_type: 'SYNC_STATE_ORDER',
                depot_no: 123456,
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 운송장정보 동기화',
              {
                work_type: 'SYNC_DELIV_ORDER',
                depot_no: 123456,
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 SKU 가져오기',
              {
                work_type: 'SCRAP_SKU',
                depot_no: 123456,
                api_callback_url: 'https://test.io/callback',
              },
              '# G마켓 물류 SKU 동기화',
              {
                work_type: 'SYNC_SKU',
                list: [
                  'S381E2123456',
                  'S381E2123457',
                ],
                fields: [
                  'stock_cnt_real',
                ],
                api_callback_url: 'https://test.io/callback',
              },
            ],
            response: [
              {
                title: 'results',
                required: 'O',
                type: 'Array',
                desc: '결과\n(실패시 error 로 출력)',
              },
              {
                title: 'work_no',
                required: 'O',
                type: 'Number',
                desc: '등록된 작업번호',
                indent: 1,
              },
              {
                title: 'error_code',
                required: '',
                type: 'String',
                desc: '실패시 출력되는 에러코드',
                indent: 1,
              },
              {
                title: 'message',
                required: 'O',
                type: 'String',
                desc: '성공, 실패 메세지',
                indent: 1,
              },
              {
                title: 'list',
                required: '',
                type: 'String[]',
                desc: '등록한 list 정보\n(성공인경우 출력)',
                indent: 1,
              },
              {
                title: 'error_list',
                required: '',
                type: 'String[]',
                desc: '실패 list 정보',
                indent: 1,
              }
            ],
            response_example: {
              results: [
                {
                  work_no: 487772398,
                  message: '작업이 정상적으로 등록되었습니다.',
                  list: [
                    '3938009934902534',
                    '3938713558156561'
                  ]
                }
              ]
            },
            error_example: {
              error: [
                {
                  work_no: 0,
                  error_code: 'e6999',
                  messages: [
                    '작업등록에 실패하였습니다.'
                  ],
                  error_list: [
                    '3938009934902534',
                    '3938713558156561'
                  ]
                }
              ]
            }
          },
        ],
      }
    ] : []),
  ],
});

export default data;
